import instance from "../instance";
import {instance2} from "../instance";
export const homeApi = {
  getBanners: (body:any) => instance2.get('/get_website_banners', body),
  getCategories: (body:any) => instance2.post('/merchants_category',body),
  getMerchants: (body:any) => instance2.post('/getMerchants',body),
  getPopularCategories: (body:any) => instance2.post('merchants_category',body),
  getPremiunPartners: (body:any) => instance2.post('/get_organisations',body),
}
